import { render, staticRenderFns } from "./invoice-project.vue?vue&type=template&id=34cacb7c"
import script from "./invoice-project.vue?vue&type=script&lang=js"
export * from "./invoice-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports